import * as yup from "yup";

export const certificadoSchema = yup.object().shape({
  id_certificado: yup.number().nullable(),
  id_condominio_cond: yup.number().required("O condomínio é obrigatório"),
  arquivo: yup.string().required("O nome arquivo é obrigatóio"),
  senha: yup
    .string()
    .min(4, "A senha deve ter pelo menos 4 caracteres")
    .required("A senha é obrigatória"),
  confirmarSenha: yup
    .string()
    .oneOf([yup.ref("senha")], "A confirmação da senha não confere")
    .required("A confirmação de senha é obrigatória"),
  data_emissao: yup.date().required("A data de emissão é obrigatória"),
  data_expiracao: yup.date().required("A data de emissão é obrigatória"),
  file: yup.mixed<ArrayBuffer | string>().required("O arquivo é obrigatório"),
  fileName: yup.string().default(""),
});
